<style lang="scss">
  @import "@/assets/scss/vuexy/pages/List.scss";
</style>

<template>
  <div id="data-list-list-view" class="data-list-container mt-2 px-">
     <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-button @click="goToAdd()" class="bg-primary float-right" type="filled">{{$t("Labels.Add")}}</vs-button>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col">
          <vs-input class="w-full" :placeholder="$t('Labels.Name')" v-model="filter.name"/>
      </div>
      <div class="vx-col">
        <vs-button  @click="getResponse()" radius color="primary" type="filled" icon="search"></vs-button>
      </div>
    </div>
    <vs-table v-if="response" :data="response"
      @selected="goToDetail">
      <template slot="thead">
        <vs-th sort-key="name">
          {{$t('Labels.Name')}}
        </vs-th>
        <vs-th sort-key="network_server_id">
          {{$t('Labels.Network')}}
        </vs-th>
        <vs-th sort-key="created_at">
          {{$t('Labels.CreatedAt')}}
        </vs-th>
      </template>

      <template  slot-scope="{data}">
        <vs-tr :data="item" :key="index" v-for="(item, index) in data" >
          <vs-td :data="item.name">
            {{item.name}}
          </vs-td>
          <vs-td :data="item.network_server_id">
            {{item.network_server_id}}
          </vs-td>
          <vs-td :data="item.created_at">
            {{item.created_at}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    </vs-table>
  </div>
</template>

<script>
import {request} from '@/request.js'

export default {
  components: {
  },
  data () {
    return {
      isMounted: false,
      response: [],
      filter:{
        name:''
      }
    }
  },

  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    }
  },


  methods: {
    async getResponse () {
      this.$vs.loading()

      const params = {
        url: 'device_profiles',
        method: 'GET',
        params:this.filter
      }
      await request(params).then(response => {
        this.response = response.data.data
      }).catch(() => {
        this.response = []
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    goToDetail (tr) {
      window.location.href = `/profiles/${tr.uuid}`
    },
    goToAdd () {
      window.location.href = '/profiles/add'
    }
  },

  created () {
    this.$route.meta.breadcrumb[1].title = this.$t('Path.Profiles')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.List')
    this.$route.meta.pageTitle = this.$t('Path.List')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})
    this.getResponse()
  },

  mounted () {
    this.isMounted = true
  }

}
</script>
